import z from "zod";

export const contentReviewerFiltersSchema = z.object({
  persona: z.string().nullable().default(null),
  status: z
    .enum(["image_generated", "reviewed", "approved", "posted"])
    .nullable()
    .default(null),
  start_date: z.string().nullable().default(null),
  end_date: z.string().nullable().default(null),
  order_by: z.enum(["timestamp", "ai_rating", "rating"]).default("timestamp"),
});

export type ReviewContentFilters = z.infer<typeof contentReviewerFiltersSchema>;
